<template>
  <div>
    <img :src="`${imgUrl}/cruiseDetail/pc_ticket_contains.png`"/>
  </div>
<!--    <div class="full-board-details">-->
<!--      <div class="details-title-bar">-->
<!--        <h3 class="details-title">船票包含：</h3>-->
<!--      </div>-->
<!--      <ul class="project-list">-->
<!--        <li v-for="(item,index) in projects" :key="index">-->
<!--          <img :src="item.src"/>-->
<!--          <div>{{item.title}}</div>-->
<!--        </li>-->
<!--      </ul>-->
<!--    </div>-->
</template>

<script>
export default {
  name: "FullBoardDetails",
  props: {
    targetStr: {
      type: String,
      default: ''
    },
    containerStr: {
      type: String,
      default: ''
    },
    isFold: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isFold(val) {
      if(val) this.isContentFold = this.isListFold = val;
    }
  },
  data() {
    return {
      isListFold: false,
      isContentFold: false,
      imgUrl: process.env.VUE_APP_IMG_URL,
      projects: []
    }
  },
  created(){
    this.projects = [{
      title: "豪华住宿",
      src: `${this.imgUrl}/cruiseSearch/icons/icon-accommodation-blue.png`
    },{
      title: "寰宇美食",
      src: `${this.imgUrl}/cruiseSearch/icons/icon-fine-food-blue.png`
    },{
      title: "招牌演出",
      src: `${this.imgUrl}/cruiseSearch/icons/icon-signboard-show-blue.png`
    },{
      title: "水上乐园",
      src: `${this.imgUrl}/cruiseSearch/icons/icon-water-park-blue.png`
    },{
      title: "运动健身",
      src: `${this.imgUrl}/cruiseSearch/icons/icon-sports-blue.png`
    },{
      title: "室内外泳池",
      src: `${this.imgUrl}/cruiseSearch/icons/icon-swimming-pool-blue.png`
    },{
      title: "科技游乐",
      src: `${this.imgUrl}/cruiseSearch/icons/icon-science-amusement-blue.png`
    },{
      title: "派对游戏",
      src: `${this.imgUrl}/cruiseSearch/icons/icon-party-blue.png`
    },{
      title: "儿童青少年活动中心",
      src: `${this.imgUrl}/cruiseSearch/icons/icon-children-blue.png`
    }]
  },
  methods: {
    handleHide() {
      this.isListFold = false;
      this.isContentFold = false;
    }
  }
}
</script>

<style lang="less" scoped>
.tooltip-arrow:before {
  bottom: 0;
  border-width: 0 15px 15px;
  border-bottom-color: #54A3DE;
}
.full-board-details {
  width: 100%;
  padding: 5px 10px;

  & .details-title-bar {
    border-bottom: 2px solid #fbc500;
    & .details-title {
      width: 90px;
      margin: 0;
      padding: 0 0 5px;
      font-size: 18px;
      font-weight: bold;
      color: #333333;
      border-bottom: 2px solid #fbc500;
    }
  }

  & .project-fold-btn {
    text-align: center;
    margin: 15px auto;
    & > img {
      cursor: pointer;
      height: 8px;
      animation: all .2s;
      transform: rotate(0deg);
      &.is-fold {
        transform: rotate(180deg);
      }
    }
  }

  & .project-list {
    overflow: hidden;
    margin: 0;
    padding: 0;
    & > li {
      float: left;
      width: 33.33%;
      padding: 20px 1.5% 0;
      overflow: hidden;
      color: #747d80;
      & > img {
        float: left;
        height: 30px;
        margin-right: 5px;
      }
      & > div {
        font-size: 14px;
        overflow: hidden;
        height: 30px;
        line-height: 30px;
      }
    }
  }

  & .project-introduce {
    word-wrap:break-word;
    word-break:normal;
    color: #999999;
  }
}

.tooltip {
  &.b-tooltip {
    opacity: 1;
  }

  & .tooltip-arrow {
    top: 50%;
    left: -8px;
    margin-top: -10px;

    &::before {
      position: absolute;
      top: 0;
      left: -1px;
      content: '';
      width: 16px;
      height: 20px;
      background: #FFFFFF;
      transform: rotate(135deg);
      box-shadow: 2px 2px 6px 0 rgba(0, 0, 0, .2);
    }

    &::after {
      position: absolute;
      top: -10px;
      left: 6px;
      content: '';
      width: 16px;
      height: 40px;
      background: #FFFFFF;
    }
  }

  & .tooltip-inner {
    width: 400px;
  }
}
</style>
<style lang='less'>
.bs-tooltip-bottom {
  bottom: -15px !important;
  & .arrow {
    position: absolute;
    top: -15px !important;
    width: 0;
    height: 0;
    border-top: 15px solid #FFFFFF;
    border-right: 15px solid transparent;
    border-left: 15px solid transparent;
  }
}
.bs-tooltip-top {
  top: -15px !important;
  & .arrow {
    position: absolute;
    bottom: -15px !important;
    width: 0;
    height: 0;
    border-top: 15px solid #FFFFFF;
    border-right: 15px solid transparent;
    border-left: 15px solid transparent;
  }
}
</style>